import { Box, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import { MainInput, SuccessButton } from "../index";
import { Constants } from "../../utils/constants";
import { useEffect, useState } from "react";
import { isValidUrl } from "../../utils/stringFormat";

export default function ProjectEditRedirectModal({
    open,
    onClose,
    onFinish,
    original,
    final,
}) {
    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: {
            xs: 360,
            sm: 450,
        },
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[currentMode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    };
    const [finalError, setFinalError] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [match, setMatch] = useState("");

    useEffect(() => {
        setFinalError(false);
        setDisabled(false);
        setMatch(final);
    }, [open, original, final]);
    const handleSubmit = (e) => {
        e.preventDefault();
        var isValid = true;
        if (!isValidUrl(match)) {
            setFinalError(true);
            isValid = false;
        } else {
            setFinalError(false);
        }
        if (!isValid) {
            return;
        }
        setDisabled(true);
        onFinish({ match });
    }
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-project-create-title"
            aria-describedby="modal-project-create-description"
        >
            <Box sx={style}>
                <Typography id="modal-project-create-title" variant="h6" component="h2" fontWeight={"bold"}>
                    Edit Redirect mapping
                </Typography>
                <Box component={"form"} onSubmit={handleSubmit} noValidate mt={"1.5rem"}>
                    <Stack direction={"column"} spacing={"1.25rem"}>
                        <Typography
                            sx={{
                                fontSize: Constants.Styles.fontSize.sm,
                                lineHeight: Constants.Styles.lineHeight.sm,
                                fontWeight: Constants.Styles.fontWeight.medium,
                                color: Constants.Colors[currentMode].mutedForeground,
                            }}
                        >
                            Original: {original}
                        </Typography>
                        <MainInput
                            key="match"
                            name="match" type="text"
                            placeholder={`mapping URL`}
                            required
                            error={finalError}
                            helperText={finalError ? "mapping URL must be a valid URL" : ""}
                            value={match}
                            onChange={(e) => setMatch(e.target.value)}
                        />
                        <Stack direction={"row"} justifyContent={"flex-end"}>
                            <SuccessButton type="submit" text="Save" size="medium" fullWidth={false} disabled={disabled} isSubmitting={disabled} />
                        </Stack>
                    </Stack>
                </Box>
            </Box>
        </Modal>
    );
}